import { Injectable } from '@angular/core';
import { AllocationViewActionsFacade } from '../allocation-view-actions.facade';
import { AllocationViewSelectedEntityModel, AllocationViewTruckReleaseModel } from '../../models';
import { AllocationViewActionInterface } from '../models';
import { filter, take } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import {
  AllocationViewTruckReleaseAction,
  AllocationViewTruckReleaseActionPrepare,
  AllocationViewTruckReleaseActionSetInitialState,
} from './allocation-view-truck-release-action.actions';
import { AllocationViewTruckReleaseActionState } from './allocation-view-truck-release-action.state';

@Injectable({ providedIn: 'root' })
export class AllocationViewTruckReleaseActionFacade implements AllocationViewActionInterface {
  loaded$: Observable<boolean> = this.store.select(AllocationViewTruckReleaseActionState.getLoaded);
  preparedDetails$: Observable<AllocationViewTruckReleaseModel> = this.store.select(
    AllocationViewTruckReleaseActionState.getPreparedDetails,
  );

  constructor(
    private allocationViewActionsFacade: AllocationViewActionsFacade,
    private translateService: TranslateService,
    private store: Store,
  ) {}

  truckRelease(data: AllocationViewTruckReleaseModel): void {
    this.allocationViewActionsFacade.actionIdentifier$.pipe(filter(Boolean), take(1)).subscribe(() => {
      this.store.dispatch(new AllocationViewTruckReleaseAction(data));
    });
  }

  loadAll(): void {
    this.store.dispatch(new AllocationViewTruckReleaseActionSetInitialState());
    this.allocationViewActionsFacade.actionIdentifier$
      .pipe(filter(Boolean), take(1))
      .subscribe(({ identifier }: AllocationViewSelectedEntityModel) => {
        this.store.dispatch(new AllocationViewTruckReleaseActionPrepare(identifier, this.translateService.currentLang));
      });
  }

  setInitialState(): void {
    this.store.dispatch(new AllocationViewTruckReleaseActionSetInitialState());
  }
}
